<template>
    <form-row title="Who is Responsible for their Construction?">
        <div class="flex-1">
            <buyer-seller-split
                field="roads_who_responsible"
                :value="commercial.roads_who_responsible"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
import BuyerSellerSplit from '../buyer-seller-split.vue';

export default {
    components: {
        BuyerSellerSplit,
    },

    props: {
        commercial: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
